// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_GO_BOTTOM = "Dole";
export const BZ2_GO_NEXT = "\u010eal\u0161ia";
export const BZ2_GO_PREVIOUS = "Predo\u0161l\u00e1";
export const BZ2_GO_TOP = "Hore";
export const CANCEL = "Zru\u0161";
export const GO_PAGING = "Cho\u010f";
export const OUT_OF = "z";
export const PAGE = "Strana";
